import React from 'react';
import PropTypes from 'prop-types';
import getPageSize from '../util/pageSize';
import { WindowHelperWrapper } from "../util/WindowHelper";
import PaginationComponent from "./PaginationComponent";

const MAX_TOTAL_COUNT = 10000;

const BUTTON_BREAKPOINTS = [480, 768, 1024];
const DEFAULT_BUTTON_COUNTS = [0, 1, 2, 3];

export const getPagingInfo = (props) => {
  const totalCount = props.totalCount || 0;
  const dataSize = props.data && props.data.length || 0;
  const hasPagination = totalCount > dataSize;
  const pageSize = props.pageSize || getPageSize();
  const pageCount = totalCount > MAX_TOTAL_COUNT ? Math.ceil(MAX_TOTAL_COUNT / pageSize) : Math.ceil(totalCount / pageSize);
  return {
    totalCount,
    dataSize,
    hasPagination,
    pageSize,
    pageCount
  };
}

export default class Pagination extends React.Component {
  static propTypes = {
    activePage: PropTypes.number,
    data: PropTypes.array,
    isBranded: PropTypes.bool,
    isLoadingData: PropTypes.bool,
    maxButtons: PropTypes.number,
    onPageChange: PropTypes.func.isRequired,
    totalCount: PropTypes.number,
    windowOverride: PropTypes.object
  };

  constructor(props){
    super(props);
    this.windowHelper = WindowHelperWrapper(props.windowOverride);
    this.state = {
      activePage: props.activePage || 1,
      defaultButtonCount: 9
    };
  }

  componentDidMount() {
    this.destroyWindowWatcher = this.windowHelper.watchBreakpoints(
      BUTTON_BREAKPOINTS, this.onButtonCountChange);
  }

  componentWillUnmount() {
    this.destroyWindowWatcher();
  }

  componentWillReceiveProps(newProps) {
    const { activePage } = newProps;

    if(!!activePage && activePage !== this.state.activePage) {
      this.setState({ activePage });
    }
  }

  onButtonCountChange = (index) => {
    this.setState({
      defaultButtonCount: DEFAULT_BUTTON_COUNTS[index]
    });
  }

  handleSelect = (eventKey) => {
    this.setState({
      activePage: eventKey
    });
    this.props.onPageChange(eventKey);
  }

  hasPagination = () => {
    let totalCount = this.props.totalCount || 0;
    let dataSize = this.props.data && this.props.data.length || 0;
    let hasPagination = totalCount > dataSize;
    return hasPagination;
  }

  render() {
    if(this.props.isLoadingData){
      return null;
    }
    const pagingInfo = getPagingInfo(this.props);

    if (!pagingInfo.hasPagination) {
      return null;
    }

    const siblingPagesRange = Math.max(0,
      this.props.maxButtons ?
        (this.props.maxButtons - 3) / 2 :
        this.state.defaultButtonCount
    );

    return (
      <PaginationComponent
        currentPage={this.state.activePage}
        totalPages={pagingInfo.pageCount}
        isBranded={this.props.isBranded}
        hideFirstAndLastPageLinks={true}
        siblingPagesRange={siblingPagesRange}
        onChange={this.handleSelect}
      />
    );
  }
}
